__turbopack_context__.v({
  "author": "iWO7uq_author",
  "avatar": "iWO7uq_avatar",
  "container": "iWO7uq_container",
  "date": "iWO7uq_date",
  "name": "iWO7uq_name",
});
